<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 sm6 md5 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            General Information
          </v-card-title>
          <v-card-text>
            <div class='ma-3'>
              <span v-for='field in this.general' :key='field.key'>
                <v-text-field v-if="field.referencedProperty !== undefined"
                  readonly disabled
                  :value="getReferencedProperty(field.referencedProperty)"
                  :label='field.text'
                  counter
                  maxlength='80'
                  class='pt-4'
                ></v-text-field>
                <v-text-field v-if="field.referencedProperty === undefined"
                  v-model="storeState.data.report.general[field.key]"
                  :label='field.text'
                  :data-vv-name='field.text'
                  :error-messages="errors.collect(`${field.text}`)"
                  @change='validate()'
                  v-validate="''"
                  counter
                  maxlength='80'
                  class='pt-4'
                ></v-text-field>
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md5 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Meter Information
          </v-card-title>
          <v-card-text>
            <div class='ma-3'>
              <span v-for='field in this.meter' :key='field.key'>
                <v-text-field v-if="field.referencedProperty !== undefined"
                  readonly disabled
                  :value="getReferencedProperty(field.referencedProperty)"
                  :label='field.text'
                  counter
                  maxlength='80'
                  class='pt-4'
                ></v-text-field>
                <v-text-field v-if="field.referencedProperty === undefined"
                  v-model='storeState.data.report.meter[field.key]'
                  :label='field.text'
                  :data-vv-name='field.text'
                  :error-messages="errors.collect(`${field.text}`)"
                  @change='validate()'
                  v-validate="''"
                  counter
                  maxlength='80'
                  class='pt-4'
                ></v-text-field>
              </span>
            </div>
          </v-card-text>
        </v-card>
        <div class='pt-4'>
          <v-card>
            <v-card-title class='headline font-weight-regular oem-color'>
              General Notes
            </v-card-title>
            <v-card-text>
              <div class='ma-3'>
                <v-textarea
                  key="generalNotes"
                  v-model='storeState.data.report.generalNotes.notes'
                  data-vv-name='generalNotes.notes'
                  :error-messages="errors.collect('generalNotes.notes')"
                  @change='validate()'
                  v-validate="''"
                  maxlength='1000'
                  label="Notes"
                  rows="19"
                  no-resize
                  counter
                  class='pt-4'
                ></v-textarea>
                <div style="height:6px;"></div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
      <v-flex xs12 md10 class='pa-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
              Measurements
              <v-spacer/>
              <v-btn class='oem-color ma-0' flat @click='updateValues()'>
                <v-icon>refresh</v-icon>
                Update powermeter values
              </v-btn>
            </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 lg6 class='pa-3'>
                Measured Multimeter Values
                <v-text-field
                  v-for='field in this.activeInputs'
                  :key='field.key'
                  v-model='storeState.data.report.measuredValues[field.id]'
                  :label='field.text'
                  :data-vv-name='field.text'
                  @change='validate()'
                  class='pt-4'
                ></v-text-field>
                <v-text-field
                  v-for='field in this.activeCts'
                  :key='field.key'
                  v-model='storeState.data.report.measuredValues[field.id]'
                  :label='field.text'
                  :data-vv-name='field.text'
                  @change='validate()'
                  class='pt-4'
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6 class='pa-3'>
                Measured Powermeter Values
                <v-text-field
                  v-for='input in activeInputs'
                  v-model='storeState.data.report.meterValues[input.id]'
                  :key='input.key'
                  :label='input.text'
                  readonly
                  disabled
                  class='pt-4'
                ></v-text-field>
                <v-text-field
                  v-for='ct in activeCts'
                  v-model='storeState.data.report.meterValues[ct.id]'
                  :key='ct.key'
                  :label='ct.text'
                  readonly
                  disabled
                  class='pt-4'
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import Vue from 'vue';
import ajax from '../ajax';

export default {
  name: 'Report',

  data() {
    return {
      storeState: this.$store.state,
      general: [
        { key: 'name', text: 'Installation Site', referencedProperty: 'this.storeState.data.general.siteInfo.site' },
        { key: 'address1', text: 'Address 1', referencedProperty: 'this.storeState.data.general.siteInfo.addr1' },
        { key: 'address2', text: 'Address 2', referencedProperty: 'this.storeState.data.general.siteInfo.addr2' },
        { key: 'contractor', text: 'Electrical Contractor' },
        { key: 'electrician', text: 'Electrician' },
        { key: 'phone', text: 'Electrician Phone #' },
        { key: 'panelNumber', text: 'Panel Number', referencedProperty: 'this.storeState.data.general.siteInfo.panel' },
        { key: 'panelType', text: 'Panel Type', referencedProperty: 'this.storeState.data.general.siteInfo.type' },
        { key: 'faultCurrent', text: 'Panel Maximum Fault Current' },
        { key: 'panelLocation1', text: 'Panel Location 1', referencedProperty: 'this.storeState.data.general.siteInfo.loc1' },
        { key: 'panelLocation2', text: 'Panel Location 2', referencedProperty: 'this.storeState.data.general.siteInfo.loc2' },
      ],
      meter: [
        { key: 'manufacturer', text: 'Manufacturer', referencedProperty: '"Setra Systems, Inc."' },
        { key: 'meterNo', text: 'Product', referencedProperty: '"SPM" + this.$store.getDeviceModelNumberText() + "EDN"' },
        { key: 'sn', text: 'SN', referencedProperty: 'this.storeState.data.deviceInfo.serial' },
        { key: 'location', text: 'Meter Install Location' },
      ],
    };
  },
  computed: {
    activeInputs() {
      const activeInputs = [];
      const inputs = this.storeState.data.inputs.filter(obj => (
        obj.active
      ));
      Object.values(inputs).forEach((input) => {
        Object.values(input.lines).forEach((line) => {
          if (line.active) {
            const lineNumber = line.channel - 3 * input.id;
            activeInputs.push({
              key: `L${line.channel}`,
              text: `Input ${input.id + 1} L${lineNumber + 1}-N`,
              id: line.channel,
              line: lineNumber,
            });
          }
        });
      });
      return activeInputs;
    },
    activeCts() {
      const activeCts = [];
      const cts = this.storeState.data.allCts.filter(obj => (
        obj.active
      ));
      Object.values(cts).forEach((ct) => {
        activeCts.push({
          key: `CT${ct.channel - 5}`,
          text: `CT ${ct.channel - 5}`,
          id: ct.channel,
        });
      });
      return activeCts;
    },
  },
  methods: {
    getReferencedProperty(referencedProperty) {
      return eval(referencedProperty); // eslint-disable-line no-eval
    },
    validate() {
      this.$validator.validateAll()
        .then((isValid) => {
          this.storeState.reportValid = isValid;
        });
      this.storeState.reportDirty = true;
    },
    updateValues() {
      this.updateVoltage();
      this.updateCurrent();
      this.storeState.reportDirty = true;
    },
    updateVoltage() {
      ajax.get('data/inputs')
        .then((response) => {
          Object.values(this.activeInputs).forEach((input) => {
            let line = input.id;
            let inp = 0;
            if (input.id >= 3) {
              line -= 3;
              inp = 1;
            }
            const voltage = response.data.Input[inp].lines[line].v;
            Vue.set(this.storeState.data.report.meterValues, (inp * 3) + line, Math.round(voltage * 100) / 100);
          });
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.actualVoltage = 'No voltage present';
        });
    },
    updateCurrent() {
      ajax.get('data/cts')
        .then((response) => {
          Object.values(this.activeCts).forEach((ct) => {
            const current = response.data[ct.id - 6].a;
            Vue.set(this.storeState.data.report.meterValues, ct.id, Math.round(current * 100) / 100);
          });
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          this.actualVoltage = 'No current present';
        });
    },
  },
};
</script>
